import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Position {
	/**
	 * @path /pages/:pgid/positions
	 * @returns { positions: PGSchema.positions[] }
	 */
	async getPositions(pgid: string, query: { take?: number; skip?: number }, token: string) {
		return xget<{ positions: PGSchema.positions[] }>(`/pages/${pgid}/positions`, query, { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/positions
	 * @param position: Partial<PGSchema.positions>
	 * @returns { position: PGSchema.positions }
	 */
	async createPosition(pgid: string, position: { title: PGSchema.positions["title"]; description: PGSchema.positions["description"] }, token: string) {
		return xhttp<{ position: PGSchema.positions }>(`/pages/${pgid}/positions`, "POST", position, { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/positions/:pid
	 * @param pid
	 * @returns { position: PGSchema.positions }
	 */
	async getPosition(pgid: string, pid: string, token: string) {
		return xget<{ position: PGSchema.positions }>(`/pages/${pgid}/positions/${pid}`, {}, { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/positions/:pid
	 * @param pid
	 * @param position: Partial<PGSchema.positions>
	 * @returns { position: PGSchema.positions }
	 */
	async updatePosition(pgid: string, pid: string, position: Partial<PGSchema.positions>, token: string) {
		return xhttp<{ position: PGSchema.positions }>(`/pages/${pgid}/positions/${pid}`, "PUT", position, { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/positions/:pid
	 * @param pid
	 * @returns { position: PGSchema.positions }
	 */
	async deletePosition(pgid: string, pid: string, token: string) {
		return xhttp<{ position: PGSchema.positions }>(`/pages/${pgid}/positions/${pid}`, "DELETE", { headers: { "app-token": token! } });
	}
}
